var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrap" },
    _vm._l(_vm.buttons, function(button) {
      return _c(
        "el-button",
        {
          key: button.url,
          attrs: {
            type: "primary",
            loading: button.loading,
            disabled: button.disabled
          },
          on: {
            click: function($event) {
              return _vm.handleClick(button)
            }
          }
        },
        [_vm._v(" " + _vm._s(button.label) + " ")]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }